import { useState } from "react";

import { FileIconsDownloadIcon } from "@dotnet/telematics-design-system";

import { VehicleFilesDataDto } from "../../../../../Pages/Files";
import { VEHICLE_FILES_ACTIONS } from "../../../../../shared";
import { useFileDownload } from "../../../hooks/useFileDownload";

const useVehicleFilesInlineActions = () => {
  const { downloadFile } = useFileDownload();

  const [rowData, setRowData] = useState<VehicleFilesDataDto | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const openDialog = (data: any) => {
    setRowData(data);
    setIsOpen(true);
  };

  const closeDialog = () => {
    setRowData(null);
    setIsOpen(false);
  };

  const handleClick = (data: VehicleFilesDataDto, setIsButtonDownload?: any) =>
    downloadFile({
      queryString: data.id,
      setIsLoading: setIsButtonDownload
    });

  const inlineActions = [
    {
      title: VEHICLE_FILES_ACTIONS.Download,
      hasLoader: true,
      icon: <FileIconsDownloadIcon />,
      clickAction: handleClick,
      renderConditions: () => true
    }
  ];

  return {
    inlineActions,
    rowData,
    isOpen,
    openDialog,
    closeDialog
  };
};

export default useVehicleFilesInlineActions;
